import { IAppState } from "../../../app/appTypes"
import { IAuditEvent } from "../../../features/audit/state/auditEventTypes"

const EMPTY_AUDIT_IDS: string[] = []

export const getAuditEventIdsByEntityId = (state: IAppState, entityId: string): string[] => {
  return state.entities.auditEvents.allIdsByEntityId[entityId] || EMPTY_AUDIT_IDS
}

export const getAuditEventById = (state: IAppState, id: string): IAuditEvent =>
  state.entities.auditEvents.byId[id]
